/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Transcript_Export_Include_ReplyInputs */



/**
* | output |
* | --- |
* | "Include Reply" |
*
* @param {Transcript_Export_Include_ReplyInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const transcript_export_include_reply = /** @type {((inputs?: Transcript_Export_Include_ReplyInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Transcript_Export_Include_ReplyInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Include Reply")
	if (locale === "de") return /** @type {LocalizedString} */ ("Include Reply")
	if (locale === "it") return /** @type {LocalizedString} */ ("Include Reply")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Include Reply")
	if (locale === "es") return /** @type {LocalizedString} */ ("Include Reply")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Include Reply")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Include Reply")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Include Reply")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Include Reply")
	return /** @type {LocalizedString} */ ("Include Reply")
});